import { render, staticRenderFns } from "./CmaReadingCard.vue?vue&type=template&id=1ce08c22&scoped=true&"
import script from "./CmaReadingCard.vue?vue&type=script&lang=js&"
export * from "./CmaReadingCard.vue?vue&type=script&lang=js&"
import style0 from "./CmaReadingCard.vue?vue&type=style&index=0&id=1ce08c22&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce08c22",
  null
  
)

export default component.exports